import { useEffect, useState, useRef } from 'react'
import { Link } from 'react-scroll'

import classes from './Header.module.scss'

import { BiMenuAltRight } from 'react-icons/bi'
import { AiOutlineClose } from 'react-icons/ai'

import { HighlighterLink } from '../highlighter/HighlighterLink'

const Header = () => {
  const [isHamburgerOpen, setHamburgerOpen] = useState(false)
  const [prevScrollPos, setPrevScrollPos] = useState(0)
  const [visible, setVisible] = useState(true)

  const [size, setSize] = useState({
    width: undefined,
    height: undefined,
  })

  const menuContainerRef = useRef(null)

  const handleTabKeyPress = (e) => {
    const focusableElements = menuContainerRef.current.querySelectorAll(
      'button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )
    const firstFocusable = focusableElements[0]
    const lastFocusable = focusableElements[focusableElements.length - 1]

    if (e.key === 'Tab') {
      if (e.shiftKey && document.activeElement === firstFocusable) {
        // Shift + Tab, focus the last focusable element
        e.preventDefault()
        lastFocusable.focus()
      } else if (!e.shiftKey && document.activeElement === lastFocusable) {
        // Tab, focus the first focusable element
        e.preventDefault()
        firstFocusable.focus()
      }
    }
  }

  const handleEnterKeyPress = (e, targetName) => {
    if (e.key === 'Enter') {
      console.log('Enter key pressed', targetName)

      // Prevent the default link behavior
      e.preventDefault()
      const targetElement = document.querySelector(`[name="${targetName}"]`) // Select the element by name
      console.log(targetElement)
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
      }
      setHamburgerOpen(false)
    }
  }

  useEffect(() => {
    if (isHamburgerOpen) {
      document.body.classList.add('no-scroll')
      menuContainerRef.current.addEventListener('keydown', handleTabKeyPress)
    } else {
      document.body.classList.remove('no-scroll')
      menuContainerRef.current.removeEventListener('keydown', handleTabKeyPress)
    }
  }, [isHamburgerOpen])

  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    if (size.width > 768) {
      // console.log('hej')
      setHamburgerOpen(false)
    }
  }, [size.width])

  //! Header hide on scroll

  const updateHeaderVisibility = () => {
    const currentScrollPos = window.pageYOffset
    /* If user scrolls up, i.e. prevScrollPos > currentScrollPos === true, OR
    If the current scroll position is under header's height --> set header to visible
    */
    setVisible(prevScrollPos > currentScrollPos || currentScrollPos < 100)
    setPrevScrollPos(currentScrollPos)
  }

  useEffect(() => {
    window.addEventListener('scroll', updateHeaderVisibility)
    return () => {
      window.removeEventListener('scroll', updateHeaderVisibility)
    }
  })

  const cls = visible ? ' header_visible' : ' header_hidden'

  // todo: fix svg
  return (
    <div className={'fixed-header' + cls}>
      <header className={classes.header}>
        <div className={classes.header__content}>
          <Link
            activeClass="active"
            to="top"
            smooth={true}
            duration={500}
            className={classes.header__content__logo}
            tabIndex="0"
          >
            STINA
          </Link>
          <button
            className={classes.header__content__toggle}
            onClick={() => {
              setHamburgerOpen(!isHamburgerOpen)
            }}
            aria-label={isHamburgerOpen ? 'Close Menu' : 'Open Menu'}
            aria-expanded={isHamburgerOpen}
          >
            {isHamburgerOpen ? <AiOutlineClose /> : <BiMenuAltRight />}
          </button>
          <nav
            ref={menuContainerRef}
            className={`${classes.header__content__nav} ${
              isHamburgerOpen ? classes.isMenu : ''
            }`}
          >
            <ul className="link-wrapper">
              <li>
                <Link
                  activeClass="active"
                  tabIndex="0"
                  to="work"
                  smooth={true}
                  duration={500}
                  offset={32}
                  onKeyDown={(e) => handleEnterKeyPress(e, 'work')}
                  onClick={() => {
                    setHamburgerOpen(false)
                  }}
                >
                  <HighlighterLink>WORK</HighlighterLink>
                </Link>
              </li>
              <li>
                <Link
                  activeClass="active"
                  tabIndex="0"
                  to="about"
                  smooth={true}
                  duration={500}
                  offset={32}
                  onKeyDown={(e) => handleEnterKeyPress(e, 'about')}
                  onClick={() => {
                    setHamburgerOpen(false)
                  }}
                >
                  <HighlighterLink>ABOUT</HighlighterLink>
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </header>
    </div>
  )
}

export default Header
